import type {
  ProfilingDataDto,
  ProfilingStepRequestDto,
  UpdateProfileDto,
} from './dto';
import {
  mapProfilingDataDtoToModel,
  mapProfilingStepRequestToDto,
  mapUpdateProfileToDto,
} from './mappers';
import type {
  ProfilingData,
  ProfilingStepRequest,
  UpdateProfile,
} from './models';

import { saveOnboardingStep } from './onboarding-step';

const saveProfilingStep = saveOnboardingStep<
  ProfilingData,
  ProfilingStepRequest,
  ProfilingDataDto,
  ProfilingStepRequestDto
>('No se pudo guardar el paso de perfilamiento', {
  mapRequest: mapProfilingStepRequestToDto,
  mapResponse: mapProfilingDataDtoToModel,
});

const saveProfileAuthStep = saveOnboardingStep<
  ProfilingData,
  UpdateProfile,
  ProfilingDataDto,
  UpdateProfileDto
>('No se pudo autorizar el perfilamiento', {
  mapRequest: mapUpdateProfileToDto,
  mapResponse: mapProfilingDataDtoToModel,
});

export const saveInvestingExperience = (body: ProfilingStepRequest) =>
  saveProfilingStep('post', '/profiling/investing-experience', body);

export const saveInvestingExperienceMoral = (body: ProfilingStepRequest) =>
  saveProfilingStep('post', '/profiling/investing-experience/moral', body);

export const saveEconomicSituation = (body: ProfilingStepRequest) =>
  saveProfilingStep('put', '/profiling/economic-situation', body);

export const saveEconomicSituationMoral = (body: ProfilingStepRequest) =>
  saveProfilingStep('put', '/profiling/economic-situation/moral', body);

export const saveInvestingGoals = (body: ProfilingStepRequest) =>
  saveProfilingStep('put', '/profiling/investing-goals', body);

export const saveInvestingGoalsMoral = (body: ProfilingStepRequest) =>
  saveProfilingStep('put', '/profiling/investing-goals/moral', body);

export const saveProfileAuth = (body: UpdateProfile) =>
  saveProfileAuthStep('put', '/profiling/auth', body);
